import AddEventPage from "./AddEventPage";

export default AddEventPage;
